<div class="order-details-payment-line" [mmTestId]="'ORDER_DETAILS.PAYMENT_SECTION'">
    <div class="order-details-payment-line__title" [mmTestTarget]="'subtotal-label'">
        {{ 'PAGES.ACCOUNT.ORDERS_HISTORY.SUBTOTAL' | translate }}
        <span class="vat">{{ "PAGES.ACCOUNT.ORDERS_HISTORY.PRICE" | translate: { exclude: isEntrepreneur } }}</span>
    </div>
    <div class="order-details-payment-line__value" [mmTestTarget]="'subtotal-value'">
        {{ subtotal?.amount | currency: subtotal?.currency }}
    </div>
</div>

<div class="order-details-payment-line">
    <div class="order-details-payment-line__title" [mmTestTarget]="'shipping-label'">
        {{ 'PAGES.ACCOUNT.ORDERS_HISTORY.TOTAL_SHIPPING' | translate }}
        <span class="vat">{{ "PAGES.ACCOUNT.ORDERS_HISTORY.PRICE" | translate: { exclude: isEntrepreneur } }}</span>
    </div>
    <div class="order-details-payment-line__value" [mmTestTarget]="'shipping-value'">
        {{ shippingCost?.amount | currency: shippingCost?.currency }}
    </div>
</div>

<div *ngIf="isEntrepreneur">
  <div class="order-details-payment-line">
      <div class="order-details-payment-line__title" [mmTestTarget]="'net-with-shipping-label'">
          {{ 'PAGES.ACCOUNT.ORDERS_HISTORY.TOTAL' | translate }}
        <span class="vat">{{ 'PAGES.ACCOUNT.ORDERS_HISTORY.VAT_EXCL' | translate }}</span>
      </div>
      <div class="order-details-payment-line__value" [mmTestTarget]="'net-with-shipping-value'">
          {{ totalNet?.amount | currency: totalNet?.currency }}
      </div>
    </div>

    <div class="order-details-payment-line" [ngClass]="{'bold': !isDiscountApplied}">
      <div class="order-details-payment-line__title" [mmTestTarget]="'total-label'">
        {{ 'PAGES.ACCOUNT.ORDERS_HISTORY.TOTAL' | translate }}
        <span class="vat">{{ 'PAGES.ACCOUNT.ORDERS_HISTORY.VAT_INCL' | translate }}</span>
      </div>
      <div class="order-details-payment-line__value" [mmTestTarget]="'total-value'">
        {{ totalGross?.amount | currency: totalGross?.currency }}
      </div>
    </div>
</div>

<ng-container *ngIf="isDiscountApplied">
    <div class="order-details-payment-line">
      <div class="order-details-payment-line__title" [mmTestTarget]="'total-discount-label'">
        <strong>{{ 'PAGES.ACCOUNT.ORDERS_HISTORY.TOTAL_DISCOUNT' | translate }}</strong>
        <span class="vat"> {{ 'PAGES.ACCOUNT.ORDERS_HISTORY.VAT_INCL' | translate }}</span>
      </div>
      <div class="order-details-payment-line__value" [mmTestTarget]="'total-discount-value'">
        <strong>-{{ totalDiscount?.amount | currency: totalDiscount?.currency }}</strong>
      </div>
    </div>
</ng-container>

<div class="order-details-payment-line" [ngClass]="{'discount-applied': isDiscountApplied}">
  <div class="order-details-payment-line__title" [mmTestTarget]="'grand-total-label'">
    <strong>{{ 'PAGES.ACCOUNT.ORDERS_HISTORY.GRAND_TOTAL' | translate }}</strong>
    <span class="vat"> {{ 'PAGES.ACCOUNT.ORDERS_HISTORY.VAT_INCL' | translate }}</span>
  </div>
  <div class="order-details-payment-line__value" [mmTestTarget]="'grand-total-value'">
    <strong>{{ grandTotal?.amount | currency: grandTotal?.currency }}</strong>
  </div>
</div>

<div class="order-details-payment-line">
  <div class="order-details-payment-line__title" [mmTestTarget]="'vat-label'">
    {{ 'PAGES.ACCOUNT.ORDERS_HISTORY.VAT' | translate }}
  </div>
  <div class="order-details-payment-line__value" [mmTestTarget]="'vat-title'">
    {{ vat?.amount | currency: vat?.currency }}
  </div>
</div>
